import store from "../store-root";
import api from "../../service/api";

const moduleName = "provider";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //获取供应商列表;
    async getProviderList() {
      let result = await api.get("/api/Provider");
      return result.data;
    },
  },
});

export default moduleName;
